import {
  ERROR_INVALID_CHARACTERS,
  ERROR_NAME_REQUIRED,
} from "../consts/messages";
import { memo, useCallback, useState } from "react";

import { PLAN_NAME_LIMIT } from "../consts/strings";
import { TextField } from "@mui/material";

export const PlanNameInput = memo(({ name, onChange, setIsNameValid }) => {
  const [value, setValue] = useState(name);
  const [helperText, setHelperText] = useState();

  const handleChange = useCallback(
    (value) => {
      setIsNameValid && setIsNameValid(false);
      setValue(value);
      if (!value) {
        setHelperText(ERROR_NAME_REQUIRED);
        return;
      }
      if (value.length > 39) {
        setHelperText(PLAN_NAME_LIMIT);
        return;
      }
      const regex = new RegExp(`^[-@/\\sA-Za-z0-9]+$`);
      if (regex.test(value)) {
        setHelperText();
        setIsNameValid && setIsNameValid(true);
        onChange && onChange(value);
      } else {
        setHelperText(ERROR_INVALID_CHARACTERS);
      }
    },
    [onChange, setIsNameValid]
  );

  return (
    <TextField
      fullWidth
      label={"Plan Name"}
      placeholder={"Enter Name"}
      variant={"outlined"}
      value={value}
      error={!!helperText}
      helperText={helperText}
      onChange={(e) => handleChange(e.target.value)}
    />
  );
});
